<template>
	<div class="compared-table">
		<table class="table-container">
			<tr class="table-header">
				<th class="header6" style="padding-left: 35px">{{ property.address }}</th>
				<th class="header6">Count</th>
				<th class="header6">Median Building<br />Assessment<br />per SqFt</th>
			</tr>
			<tr class="comp table-value-sec" v-for="(comp, i) in comparedTable" :key="i">
				<td class="value header4" style="padding-left: 35px">
					<span>{{ comp.label }}</span>
					<i
						v-if="comp.tooltip"
						v-tooltip="{
							content: comp.tooltip,
							placement: 'top-center',
							classes: ['info'],
							targetClasses: ['it-has-a-tooltip'],
							offset: 0,
							delay: {
								show: 0,
								hide: 300,
							},
						}"
						class="material-icons-outlined"
						>info</i
					>
				</td>
				<td class="value header4">{{ comp.count }}</td>
				<td class="value header4">{{ comp.buildingSqFt | numberWithCommas }}</td>
			</tr>
		</table>
	</div>
</template>

<script>
export default {
	name: "comps-in-area",
	computed: {
		comparedTable() {
			return this.$store.getters.getAllPropertyData.comparedTable;
		},
		property() {
			return this.$store.getters.getAllPropertyData;
		},
	},
};
</script>
<style lang="scss">
.tooltip {
	display: block !important;
	z-index: 10000;
	.tooltip-inner {
		background: black;
		color: white;
		border-radius: 16px;
		padding: 5px 10px 4px;
	}

	.tooltip-arrow {
		width: 0;
		height: 0;
		border-style: solid;
		position: absolute;
		margin: 5px;
		border-color: black;
		z-index: 1;
	}

	&[x-placement^="top"] {
		margin-bottom: 5px;

		.tooltip-arrow {
			border-width: 5px 5px 0 5px;
			border-left-color: transparent !important;
			border-right-color: transparent !important;
			border-bottom-color: transparent !important;
			bottom: -5px;
			left: calc(50% - 5px);
			margin-top: 0;
			margin-bottom: 0;
		}
	}
	&.info {
		$color: rgba(#6100ff, 1);
		.tooltip-inner {
			background: $color;
			color: white;
			padding: 24px;
			border-radius: 5px;
			box-shadow: 0 5px 30px rgba(black, 0.5);
			max-width: 250px;
		}

		.tooltip-arrow {
			border-color: $color;
		}
	}

	&[x-placement^="bottom"] {
		margin-top: 5px;

		.tooltip-arrow {
			border-width: 0 5px 5px 5px;
			border-left-color: transparent !important;
			border-right-color: transparent !important;
			border-top-color: transparent !important;
			top: -5px;
			left: calc(50% - 5px);
			margin-top: 0;
			margin-bottom: 0;
		}
	}

	&[x-placement^="right"] {
		margin-left: 5px;

		.tooltip-arrow {
			border-width: 5px 5px 5px 0;
			border-left-color: transparent !important;
			border-top-color: transparent !important;
			border-bottom-color: transparent !important;
			left: -5px;
			top: calc(50% - 5px);
			margin-left: 0;
			margin-right: 0;
		}
	}

	&[x-placement^="left"] {
		margin-right: 5px;

		.tooltip-arrow {
			border-width: 5px 0 5px 5px;
			border-top-color: transparent !important;
			border-right-color: transparent !important;
			border-bottom-color: transparent !important;
			right: -5px;
			top: calc(50% - 5px);
			margin-left: 0;
			margin-right: 0;
		}
	}

	&[aria-hidden="true"] {
		visibility: hidden;
		opacity: 0;
		transition: opacity 0.15s, visibility 0.15s;
	}

	&[aria-hidden="false"] {
		visibility: visible;
		opacity: 1;
		transition: opacity 0.15s;
	}
}
</style>
<style scoped lang="scss">
.compared-table {
	margin-top: 35px;
	padding-bottom: 45px;

	.table-header {
		.header6 {
			font-weight: 700;
			font-size: 17px;
			line-height: 25px;
		}
	}
	.table-container {
		border-collapse: collapse;
		// width: 100%;
		// table-layout: fixed;
		width: 775px;
		th {
			padding: 12px 0;
			text-align: left;
			background-color: var(--primary);
			color: #f6f4f3;
			font-weight: 500;
			height: 100px;
		}
		tr {
			border-radius: 8px;
			height: 75px;
		}
		td,
		th {
			// border: 1px solid #ddd;
			padding: 8px;
		}
		.header4 {
			color: #595959;
		}
		tr:nth-child(2n + 3) {
			background: rgba(97, 0, 255, 0.05);
		}
	}
}
</style>
